import gsap from 'gsap';

class Form {
  constructor() {
    this.section = document.querySelector('.s-form');

    this.form = {
      label: document.querySelectorAll('label'),
      submit: document.querySelector('.form-submit'),
      field: document.querySelectorAll('.form-field'),
      checkbox: document.querySelector('.form-checkbox'),
      notification: document.querySelector('.form-notification'),
    };

    this.accept = false;
  }

  init = () => {
    this.events();

    gsap.to(this.form.field, {
      borderColor: '#707070',
    });
  }

  events = () => {
    document.addEventListener('invalid', (e) => {
      this.errors(e);
      e.preventDefault();
    }, true);

    [...this.form.field].forEach((e) => {
      e.addEventListener('keyup', this.validate);
      e.addEventListener('mouseenter', this.enter);
    });

    this.form.submit.addEventListener('click', this.send);
    this.form.checkbox.addEventListener('click', this.check);
  }

  check = () => {
    if (this.accept === true) {
      this.accept = false;
      this.form.checkbox.classList.remove('is-checked');
    } else {
      this.accept = true;
      this.form.checkbox.classList.add('is-checked');
      gsap.to(this.form.checkbox, {
        borderColor: '#707070',
      });
    }
  }

  send = () => {
    if (this.accept === false) {
      gsap.to(this.form.checkbox, {
        borderColor: '#c94450',
      });
    } else {
      gsap.to(this.form.checkbox, {
        borderColor: '#707070',
      });
    }
  }

  validate = (e) => {
    const { target } = e;
    const value = target.value.length;

    if (value === 0) {
      target.classList.remove('is-valid');
    } else {
      target.classList.add('is-valid');
    }
  }

  errors = (e) => {
    const el = e.target;

    this.form.notification.innerHTML = 'Please review the form and correct the highlighted items.';

    gsap.to(el, {
      borderColor: '#c94450',
    });
  }

  enter = (e) => {
    gsap.to(e.target, {
      borderColor: '#707070',
    });
  }
}

export default Form;
